// cart-bundle-popup.js
import { ThemeEvents } from '@theme/events';

const dialog = document.getElementById('cart-bundle-popup');
const contentEl = dialog?.querySelector('[data-bundle-popup-content]');

function getPopupState(cart) {
  const categories = new Set();
  cart.items.forEach((item) => {
    const cat = item.properties?.['_bundle_category'];
    if (cat) categories.add(cat);
  });

  const hasTop = categories.has('top');
  const hasBlazer = categories.has('blazer');
  const hasBottom = categories.has('bottom');
  const distinctCount = [hasTop, hasBlazer, hasBottom].filter(Boolean).length;

  if (hasTop && hasBlazer && hasBottom) return 'congrats';
  if (distinctCount === 2) return 'complete_the_set';
  return null;
}

function closeCartDrawer() {
  const cartDrawerDialog = document.querySelector('cart-drawer-component dialog');
  if (cartDrawerDialog?.open) {
    cartDrawerDialog.close();
  }
}

function renderPopup(state) {
  if (!dialog || !contentEl) return;

  if (state === 'complete_the_set') {
    contentEl.innerHTML = `
      <p class="cart-bundle-popup__heading">Complete the Set</p>
      <p class="cart-bundle-popup__text">You're ONE matching item away from a discount!</p>
      <a href="https://shopsofset.com/collections/all" class="button cart-bundle-popup__cta">Keep Shopping</a>
    `;
  } else if (state === 'congrats') {
    contentEl.innerHTML = `
      <p class="cart-bundle-popup__heading">Congrats!</p>
      <p class="cart-bundle-popup__text">You earned a discount for completing the set.</p>
      <div class="cart-bundle-popup__actions">
        <button type="button" class="button cart-bundle-popup__cta" data-bundle-popup-claim>Claim</button>
      </div>
    `;
  }

  closeCartDrawer();
  if (!dialog.open) {
    dialog.showModal();
  }
}

const STORAGE_KEY = 'bundlePopupCurrentRank';

const STATE_RANK = {
  complete_the_set: 1,
  congrats: 2,
};

function getCurrentRank() {
  return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
}

function setCurrentRank(rank) {
  sessionStorage.setItem(STORAGE_KEY, String(rank));
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const cart = event.detail?.resource;
  if (!cart?.items) return;

  const state = getPopupState(cart);
  const rank = state ? STATE_RANK[state] : 0;
  const previousRank = getCurrentRank();

  // Always record the current actual rank, whether it went up or down.
  setCurrentRank(rank);

  // Only pop up when moving to a HIGHER rank than the last known state.
  // Removals lower the rank silently; building back up afterward correctly
  // fires again since we compare against wherever you currently are.
  if (!state || rank <= previousRank) return;

  requestAnimationFrame(() => {
    renderPopup(state);
  });
});

dialog?.addEventListener('click', (event) => {
  if (event.target.closest('[data-bundle-popup-close]')) {
    dialog.close();
  }

  if (event.target.closest('[data-bundle-popup-claim]')) {
    dialog.close();
    const cartDrawer = document.querySelector('cart-drawer-component');
    cartDrawer?.querySelector('button[on\\:click="/open"]')?.click();
  }
});


// // cart-bundle-popup.js
// import { ThemeEvents } from '@theme/events';

// const dialog = document.getElementById('cart-bundle-popup');
// const contentEl = dialog?.querySelector('[data-bundle-popup-content]');

// function getPopupState(cart) {
//   const categories = new Set();
//   cart.items.forEach((item) => {
//     const cat = item.properties?.['_bundle_category'];
//     if (cat) categories.add(cat);
//   });

//   const hasTop = categories.has('top');
//   const hasBlazer = categories.has('blazer');
//   const hasBottom = categories.has('bottom');
//   const distinctCount = [hasTop, hasBlazer, hasBottom].filter(Boolean).length;

//   if (hasTop && hasBlazer && hasBottom) return 'congrats';
//   if (distinctCount === 2) return 'complete_the_set';
//   return null;
// }

// /**
//  * FIX: Only touch the cart drawer if it is ACTUALLY open. The old code
//  * unconditionally called cartDrawerDialog.close() on the native <dialog>,
//  * bypassing the theme's own DialogComponent cleanup and doing so even when
//  * the drawer was never opened. That could throw or leave dialog state
//  * corrupted, which silently blocked later cart-icon updates until a full
//  * page reload.
//  */
// function closeCartDrawer() {
//   const cartDrawerComponent = document.querySelector('cart-drawer-component');
//   const cartDrawerDialogEl = cartDrawerComponent?.querySelector('dialog');

//   // Nothing to close — leave the drawer completely untouched.
//   if (!cartDrawerDialogEl?.open) return;

//   try {
//     if (typeof cartDrawerComponent.closeDialog === 'function') {
//       cartDrawerComponent.closeDialog();
//       return;
//     }
//   } catch (err) {
//     console.warn('[BundlePopup] closeDialog() failed, falling back:', err);
//   }

//   try {
//     cartDrawerDialogEl.close();
//   } catch (err) {
//     console.warn('[BundlePopup] Native dialog close failed:', err);
//   }
// }

// function renderPopup(state) {
//   if (!dialog || !contentEl) return;

//   if (state === 'complete_the_set') {
//     contentEl.innerHTML = `
//       <p class="cart-bundle-popup__heading">Complete the Set</p>
//       <p class="cart-bundle-popup__text">You're ONE matching item away from a $30 discount!</p>
//       <a href="https://shopsofset.com/collections/all" class="button cart-bundle-popup__cta">Keep Shopping</a>
//     `;
//   } else if (state === 'congrats') {
//     contentEl.innerHTML = `
//       <p class="cart-bundle-popup__heading">Congrats!</p>
//       <p class="cart-bundle-popup__text">You earned a $30 discount for completing the set.</p>
//       <div class="cart-bundle-popup__actions">
//         <button type="button" class="button cart-bundle-popup__cta" data-bundle-popup-claim>Claim</button>
//       </div>
//     `;
//   }

//   try {
//     closeCartDrawer();
//   } catch (err) {
//     console.warn('[BundlePopup] closeCartDrawer threw unexpectedly:', err);
//   }

//   requestAnimationFrame(() => {
//     try {
//       if (!dialog.open) {
//         dialog.showModal();
//       }
//     } catch (err) {
//       console.warn('[BundlePopup] Failed to open bundle popup dialog:', err);
//     }
//   });
// }

// const STORAGE_KEY = 'bundlePopupCurrentRank';

// const STATE_RANK = {
//   complete_the_set: 1,
//   congrats: 2,
// };

// function getCurrentRank() {
//   return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
// }

// function setCurrentRank(rank) {
//   sessionStorage.setItem(STORAGE_KEY, String(rank));
// }

// document.addEventListener(ThemeEvents.cartUpdate, (event) => {
//   const cart = event.detail?.resource;
//   if (!cart?.items) return;

//   const state = getPopupState(cart);
//   const rank = state ? STATE_RANK[state] : 0;
//   const previousRank = getCurrentRank();

//   setCurrentRank(rank);

//   if (!state || rank <= previousRank) return;

//   requestAnimationFrame(() => {
//     renderPopup(state);
//   });
// });

// dialog?.addEventListener('click', (event) => {
//   if (event.target.closest('[data-bundle-popup-close]')) {
//     dialog.close();
//   }

//   if (event.target.closest('[data-bundle-popup-claim]')) {
//     dialog.close();
//     const cartDrawer = document.querySelector('cart-drawer-component');
//     cartDrawer?.querySelector('button[on\\:click="/open"]')?.click();
//   }
// });